/** Width of the red Delete action revealed behind a swiped row. */
export const SWIPE_ACTION_WIDTH = 84;

/** Movement (px) before a touch commits to an axis; below it, a tap is still a tap. */
const AXIS_LOCK_PX = 8;

/** How far across the row (fraction of its width) a swipe must carry to delete outright. */
const FULL_SWIPE_FRACTION = 0.5;

/**
 * Decide once per gesture whether a touch is a horizontal swipe or a vertical scroll.
 * Null while the finger is still inside the dead zone.
 */
export function swipeAxis(dx: number, dy: number): 'x' | 'y' | null {
  if (Math.abs(dx) <= AXIS_LOCK_PX && Math.abs(dy) <= AXIS_LOCK_PX) return null;
  return Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
}

/** Whether content pushed to `offset` (negative, px) has gone far enough to delete on release. */
export function isFullSwipe(offset: number, rowWidth: number): boolean {
  return offset < -rowWidth * FULL_SWIPE_FRACTION;
}

/**
 * Where a row rests after a horizontal drag of `dx` px: shut, open on the Delete action,
 * or -- swiped on past half the row, whether already open or in one long swipe -- deleted.
 */
export function settleSwipe(dx: number, wasOpen: boolean, rowWidth: number): 'closed' | 'open' | 'delete' {
  const final = (wasOpen ? -SWIPE_ACTION_WIDTH : 0) + dx;
  if (isFullSwipe(final, rowWidth)) return 'delete';
  return final < -SWIPE_ACTION_WIDTH / 2 ? 'open' : 'closed';
}
